import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import * as Sentry from '@sentry/react';

import Router from './components/Router';
import { SENTRY_DSN, SENTRY_ENV } from './config/env';
import './index.css';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV,
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2, // Bed 27/09/2021 will play with performance settings later on
  });
}

const helmetContext = {};

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <HelmetProvider context={helmetContext}>
        <Helmet title="Tapt | The future of the business card" />
        <Router />
      </HelmetProvider>
    </React.StrictMode>,
  );
}
